import React from 'react'

import PropTypes from 'prop-types'
import Bem from 'react-bem-helper'
import Model from 'app/models/Model'
import ImageModel from 'app/models/Image/Image'
import { breakpoints } from 'app/utils/constants'
import { canUseDOM } from 'app/utils/env-helpers'

import './ResponsiveImage.scss'

// Component model definition
export class ResponsiveImageModel extends Model {
  constructor(d) {
    super(d)
    this.small = d ? new ImageModel(d.small || d.medium || d.large) : null
    this.medium = d ? new ImageModel(d.medium || d.large || d.small) : null
    this.large = d ? new ImageModel(d.large || d.medium || d.small) : null
  }

  get currentImage() {
    if (!canUseDOM()) {
      return this.large
    }

    const width =
      global.innerWidth ||
      global.document.documentElement.clientWidth ||
      global.document.body.clientWidth

    for (const size in breakpoints) {
      if (width >= breakpoints[size].min && width <= breakpoints[size].max) {
        return this[size]
      }
    }

    return null
  }

  static props() {
    const imageProps = {
      src: PropTypes.string,
      height: PropTypes.number,
      width: PropTypes.number,
      mime: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string
    }
    return {
      small: PropTypes.shape(imageProps),
      medium: PropTypes.shape(imageProps),
      large: PropTypes.shape(imageProps),
      breakpoints: PropTypes.shape(),
      onSwitch: PropTypes.func,
      useImageSizes: PropTypes.bool,
      useRetina: PropTypes.bool,
      className: PropTypes.string
    }
  }
}

export const formatImage = (src, variant) => {
  if (!src) return null
  if (src.includes('w=')) return src
  if (variant === 'small') {
    return src.includes('?') ? `${src}&w=500` : `${src}?w=500`
  } else if (variant === 'medium') {
    return src.includes('?') ? `${src}&w=820` : `${src}?w=820`
  }
  return src.includes('?') ? `${src}&w=1280` : `${src}?w=1280`
}

export default function ResponsiveImage(props) {
  const image = new ResponsiveImageModel(props)
  const classes = new Bem('responsive-image')
  return (
    <div {...classes({ extra: props.className })}>
      <picture>
        <source
          media="(min-width: 769px)"
          srcSet={formatImage(image?.large?.src, 'large')}
        />
        <source
          media="(min-width: 431px)"
          srcSet={formatImage(image?.medium?.src, 'medium')}
        />
        <img
          src={formatImage(image?.small?.src, 'small')}
          alt={props.name}
          data-testid="responsive-image"
        />
      </picture>
    </div>
  )
}
